/*
 * Een andere maat kiezen laat de galerij staan op de foto die je bekeek.
 *
 * Broadcast springt bij elke variantwissel naar de foto van die variant
 * (updateProductImage). Elke maat van een kleur wijst dezelfde eerste foto
 * aan, dus wie naar de achterkant keek en dan M kiest, stond ineens weer op
 * pose 01. Zijn wens (10-10-2026): bij een maatwissel de pose niet aanpassen.
 *
 * Het thema vuurt theme:variant:change voordat het de foto kiest. Daar wordt
 * gekeken of alleen de maat verschilt; zo ja, dan wordt het eerstvolgende
 * theme:media:select uit dat thema tegengehouden. Een kleurwissel gaat
 * gewoon door.
 */
(function () {
  'use strict';

  var MAAT = /^(size|maat)$/i;

  function productVan(container) {
    if (container.brandProduct !== undefined) return container.brandProduct;
    var el = container.querySelector('[data-product-json]');
    try {
      container.brandProduct = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      container.brandProduct = null;
    }
    return container.brandProduct;
  }

  function variantOp(product, id) {
    return (product.variants || []).filter(function (v) {
      return String(v.id) === String(id);
    })[0];
  }

  document.addEventListener('theme:variant:change', function (event) {
    var container = event.target;
    var nieuw = event.detail && event.detail.variant;
    if (!container || !nieuw || !container.querySelector) return;

    var product = productVan(container);
    if (!product) return;

    var maat = (product.options || []).findIndex(function (o) {
      return MAAT.test(typeof o === 'string' ? o : (o && o.name) || '');
    });

    var vorig = container.brandVorigeVariant && variantOp(product, container.brandVorigeVariant);
    container.brandVorigeVariant = nieuw.id;
    if (maat === -1 || !vorig || String(vorig.id) === String(nieuw.id)) return;

    var alleenMaat = (nieuw.options || []).every(function (waarde, i) {
      return i === maat || waarde === vorig.options[i];
    });
    if (!alleenMaat) return;

    container.brandHoudPose = true;
    // Kiest het thema geen foto (variant zonder eigen beeld), dan mag de
    // vlag niet blijven hangen tot een latere klik op een duimnagel.
    setTimeout(function () {
      container.brandHoudPose = false;
    }, 0);
  });

  // De startvariant onthouden zodra de pagina er staat. Later uit het
  // id-veld lezen kan niet: dat is hidden, en het thema heeft de nieuwe
  // waarde er al in gezet (ook in defaultValue) voor wij het event zien.
  function onthoudStart() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (container) {
      var input = container.querySelector('input[name="id"]');
      if (input && !container.brandVorigeVariant) container.brandVorigeVariant = input.value;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onthoudStart);
  } else {
    onthoudStart();
  }
  document.addEventListener('shopify:section:load', onthoudStart);

  document.addEventListener(
    'theme:media:select',
    function (event) {
      // Het thema vuurt dit op de foto zelf; de vlag staat op de container
      // die theme:variant:change verstuurde, ergens daarboven.
      var container = event.target;
      while (container && !container.brandHoudPose) container = container.parentElement;
      if (!container) return;
      container.brandHoudPose = false;
      event.stopImmediatePropagation();
    },
    true
  );
})();
